// Generated by Melange

import * as Belt__Belt_Option from "melange.belt/belt_Option.js";
import * as Buhta_cabinet__DashboardContentTemplate from "../../../templates/DashboardContentTemplate.js";
import * as Buhta_cabinet__DocumentEdo from "../../../grpc/DocumentEdo.js";
import * as Buhta_cabinet__DummyTable from "../../../components/molecules/Table/DummyTable.js";
import * as Buhta_cabinet__OrgDashboardHeader from "../../../components/molecules/OrgDashboardHeader/OrgDashboardHeader.js";
import * as Buhta_cabinet__PageNav from "../../../components/molecules/PageNav.js";
import * as Buhta_cabinet__Route from "../../../Route.js";
import * as Buhta_cabinet__Table2 from "../../../components/molecules/Table/Table2.js";
import * as Buhta_cabinet__Timestamp from "../../../util/Timestamp.js";
import * as Buhta_core__GrpcState from "../../../../../../packages/core/lib/GrpcState.js";
import * as Buhta_core__Tenant from "../../../../../../packages/core/lib/Tenant.js";
import * as Curry from "melange.js/curry.js";
import * as DateTime from "../../../../../../packages/util/lib/DateTime.js";
import * as Stdlib__List from "melange/list.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

function BatchesPage(Props) {
  let org = Props.org;
  const match = React.useState(function () {
        return 1;
      });
  const page = match[0];
  const match$1 = Buhta_core__Tenant.useTenant(undefined);
  const tenant = match$1[0];
  const contextRoute = function (route) {
    return Buhta_cabinet__Route.contextRoute(tenant.ctx, org.id, route);
  };
  const match$2 = Buhta_core__GrpcState.useGrid(Buhta_cabinet__DocumentEdo.DocumentBatchService.grid, undefined);
  const dispatch = match$2[1];
  const grid = match$2[0];
  React.useEffect((function () {
          const params_expand = {
            hd: "stats",
            tl: /* [] */0
          };
          const params = {
            search: undefined,
            page: page,
            filters: /* [] */0,
            expand: params_expand
          };
          Curry._3(dispatch, undefined, params, undefined);
        }), [page]);
  const batches = typeof grid === "string" || grid.NAME !== "Data" ? /* [] */0 : grid.VAL;
  const isLoading = grid === "Loading";
  const rows = Stdlib__List.mapi((function (i, batch) {
          const stats = Belt__Belt_Option.getWithDefault(batch.stats, {
                total_count: 0,
                sign_required_count: 0,
                signed_count: 0,
                sender_sign_required_count: 0,
                sender_signed_count: 0,
                recipient_sign_required_count: 0,
                recipient_signed_count: 0
              });
          const cells_0 = {
            body: batch.code,
            style: ""
          };
          const cells_1 = {
            hd: {
              body: String(stats.total_count),
              style: ""
            },
            tl: {
              hd: {
                body: String(stats.sender_signed_count),
                style: ""
              },
              tl: {
                hd: {
                  body: String(stats.recipient_signed_count),
                  style: ""
                },
                tl: {
                  hd: {
                    body: DateTime.toLocalFormat(Buhta_cabinet__Timestamp.toDateTime(Belt__Belt_Option.getWithDefault(batch.create_time, Buhta_cabinet__Timestamp.fromString("01.01.2000")))),
                    style: ""
                  },
                  tl: /* [] */0
                }
              }
            }
          };
          const cells = {
            hd: cells_0,
            tl: cells_1
          };
          const Key = String(i);
          return JsxRuntime.jsx(Buhta_cabinet__Table2.Row.make, {
                      cells: cells,
                      route: contextRoute({
                            TAG: /* Documents */1,
                            _0: {
                              TAG: /* Batches */6,
                              _0: {
                                TAG: /* View */0,
                                _0: Belt__Belt_Option.getWithDefault(batch.id, "0")
                              }
                            }
                          })
                    }, Key);
        }), batches);
  const currentRecords = Stdlib__List.length(batches);
  return JsxRuntime.jsx(Buhta_cabinet__DashboardContentTemplate.make, {
              header: JsxRuntime.jsx(Buhta_cabinet__OrgDashboardHeader.make, {
                    title: "Реестры"
                  }),
              children: JsxRuntime.jsx("div", {
                    children: JsxRuntime.jsxs("div", {
                          children: [
                            JsxRuntime.jsx("div", {
                                  children: isLoading ? JsxRuntime.jsx(Buhta_cabinet__DummyTable.make, {}) : JsxRuntime.jsx(Buhta_cabinet__Table2.make, {
                                          header: {
                                            hd: {
                                              name: "Название",
                                              style: ""
                                            },
                                            tl: {
                                              hd: {
                                                name: "Всего документов",
                                                style: ""
                                              },
                                              tl: {
                                                hd: {
                                                  name: "Подписаны отправителем",
                                                  style: ""
                                                },
                                                tl: {
                                                  hd: {
                                                    name: "Подписаны получателем",
                                                    style: ""
                                                  },
                                                  tl: {
                                                    hd: {
                                                      name: "Дата создания",
                                                      style: ""
                                                    },
                                                    tl: /* [] */0
                                                  }
                                                }
                                              }
                                            }
                                          },
                                          rows: rows,
                                          styles: "grid-cols-[repeat(5,_auto)]"
                                        }),
                                  className: "flex-1 overflow-auto"
                                }),
                            JsxRuntime.jsx(Buhta_cabinet__PageNav.make, {
                                  page: page,
                                  setPage: match[1],
                                  currentRecords: currentRecords
                                })
                          ],
                          className: "flex h-full flex-col w-full"
                        }),
                    className: "flex flex-col w-full"
                  })
            });
}

const make = BatchesPage;

export {
  make ,
}
/* Buhta_cabinet__DashboardContentTemplate Not a pure module */
